// src/app/components/UserAvatar.tsx
//
// Avatar de usuário compartilhado — imagem real (avatar_url, StorageFile no
// R2 via presigned URL) com fallback de iniciais. Centraliza um padrão que
// antes era reimplementado (só com iniciais, sem checar avatar_url) em cada
// ponto que exibia responsável/comentário/atividade nos Boards.

import { Avatar, AvatarImage, AvatarFallback } from './ui/avatar';

interface UserAvatarProps {
  name: string;
  avatarUrl?: string | null;
  className?: string;
  fallbackClassName?: string;
}

function getInitials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return '?';
  return trimmed.slice(0, 2).toUpperCase();
}

export function UserAvatar({ name, avatarUrl, className, fallbackClassName }: UserAvatarProps) {
  return (
    <Avatar className={className}>
      {avatarUrl && <AvatarImage src={avatarUrl} alt={name} />}
      <AvatarFallback className={fallbackClassName}>{getInitials(name)}</AvatarFallback>
    </Avatar>
  );
}
